import { Component } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";

export class EnvironmentDevList {
    static list: string[] = [
        "d01-edpzero.cliente.edp.pt",
        "d01.edponline.edp.pt",
        "d02.edponline.edp.pt",
        "d03.edponline.edp.pt",

        "d01-particulares.cliente.edp.pt",
        "d02-particulares.cliente.edp.pt",
        "d03-particulares.cliente.edp.pt",
        "d04-particulares.cliente.edp.pt",

        "m01-edpzero.cliente.edp.pt",
        "m01.edponline.edp.pt",
        "m02.edponline.edp.pt",
        "m03.edponline.edp.pt",

        "m01-particulares.cliente.edp.pt",
        "m02-particulares.cliente.edp.pt",
        "m03-particulares.cliente.edp.pt",
        "m04-particulares.cliente.edp.pt",

        "t01-edpzero.cliente.edp.pt",
        "t01-particulares.cliente.edp.pt"
    ];

    static availableList: string[] = [
        "dev", "d01", "d02", "d03",
        "pre", "m01", "m02", "m03",
        "beta", "t01"
    ];

    static available(): boolean {
        return this.availableList.includes(location.host.slice(0, 3));
    }
}

@Component({
    selector: "edp-environment-switch-modal",
    templateUrl: "./edp-environment-switch-modal.component.html",
    styleUrls: ["./edp-environment-switch-modal.component.scss"]
})
export class EdpEnvironmentSwitchModalComponent {

    public environments: string[] = EnvironmentDevList.list;

    constructor(
        private readonly edpModalService: EdpModalService
    ) {
    }

    public closeModal(): void {
        this.edpModalService.close(false);
    }

    public switch(environment: string): void {
        window.location.href = `https://${environment}?Mobile=1&app=1`;
    }
}

